/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `draft` - Szkic
 * * `published` - Opublikowany
 * * `archived` - Zarchiwizowany
 */
export type QuizPushQuizStateEnum = typeof QuizPushQuizStateEnum[keyof typeof QuizPushQuizStateEnum];


export const QuizPushQuizStateEnum = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;
